import { initializeApp } from "firebase/app";
import { getFirestore /*connectDatabaseEmulator*/ } from "firebase/firestore";
import { getStorage /*connectStorageEmulator*/ } from "firebase/storage";
import { getFunctions /*connectFunctionsEmulator*/ } from "firebase/functions";
import { getAuth } from "firebase/auth";

// Export the initialized app and database as a module
export const app = initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
});
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "asia-east1");
export const auth = getAuth(app);
